import Text from "@/components/ui/text";

export interface SummaryTile {
  key: string;
  label: string;
  value: string;
}

/** The headline figures across the top of a breakdown popover. */
const SummaryTiles = ({ tiles }: { tiles: SummaryTile[] }) => (
  <div className="flex gap-2">
    {tiles.map((tile) => (
      <div
        key={tile.key}
        data-test={`kpi-tile-${tile.key}`}
        className="flex min-w-0 flex-1 flex-col justify-between gap-2 rounded-[16px] border-[0.5px] border-border-border1 p-2"
      >
        <Text as="div" variant="smBodySecondary">
          {tile.label}
        </Text>
        <Text as="div" variant="title3H1" className="truncate leading-7">
          {tile.value}
        </Text>
      </div>
    ))}
  </div>
);

export default SummaryTiles;
